import type { IFilterPanelBaseFilterDeps, IFilterPanelBaseFilterModel } from "app/pages/sales-intelligence/modules/advanced-search-filtering/types/filters";
import { FilterPanelBaseFilter } from "app/pages/sales-intelligence/modules/advanced-search-filtering/models/BaseFilter";
import type { AppsAndroidDownloadsAndEngagementDescriptionDto } from "app/pages/sales-intelligence/modules/find-apps-filters/types/description.dto";
import type { IAppsDownloadsAndEngagementFilter } from "app/pages/sales-intelligence/store/find-apps/types";
import type { ICountryObject } from "app/services/CountryService";

export abstract class BaseDownloadsAndEngagementFilter<
        TFilterValue extends IAppsDownloadsAndEngagementFilter,
        TDescriptionDto,
    >
    extends FilterPanelBaseFilter<TFilterValue, TDescriptionDto>
    implements IFilterPanelBaseFilterModel<TFilterValue, TDescriptionDto>
{
    readonly minMauOptions: readonly number[];
    readonly maxMauOptions: readonly number[];
    readonly minDownloadsOptions: readonly number[];
    readonly maxDownloadsOptions: readonly number[];
    readonly countries: readonly ICountryObject[];

    constructor(
        deps: IFilterPanelBaseFilterDeps<TFilterValue, TDescriptionDto> & {
            options: AppsAndroidDownloadsAndEngagementDescriptionDto;
            countries: readonly ICountryObject[];
        },
    ) {
        super(deps);

        const {
            options: { monthlyActiveUsersBuckets, monthlyDownloadsBuckets },
            countries,
        } = deps;

        this.minMauOptions = monthlyActiveUsersBuckets.slice(0, monthlyActiveUsersBuckets.length - 1);
        this.maxMauOptions = monthlyActiveUsersBuckets.slice(1);
        this.minDownloadsOptions = monthlyDownloadsBuckets.slice(0, monthlyDownloadsBuckets.length - 1);
        this.maxDownloadsOptions = monthlyDownloadsBuckets.slice(1);
        this.countries = countries;
    }

    isFilterDirty(currentValue: TFilterValue | undefined): boolean {
        const { country: initCountry, ...initValue } = this.initialDtoValue ?? {};
        const { country: currentCountry, ...currentFilter } = currentValue ?? {};
        return (
            (currentCountry && initCountry !== currentCountry) ||
            JSON.stringify(initValue) !== JSON.stringify(currentFilter)
        );
    }
}
